import React, { useState } from "react";
import {
  ChakraProvider,
  Box,
  Center,
  CSSReset,
  Heading,
  Collapse,
} from "@chakra-ui/react";
import TeaLogo from "../../assets/tea-logoVersion.svg";
import CustomInput from "../../components/Input";
import Button from "../../components/Button";
import { Flex } from "@chakra-ui/react";
import CustomButton from "../../components/Button";
import Data from "../../components/Data";
import axios from "axios";
import { useToast } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

function Register() {
  const toast = useToast();
  const navigate = useNavigate();

  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  //const [ConfirmPassword, setConfirmPassword] = useState("");
  const [FatherName, setFatherName] = useState("");
  const [FatherBirthDate, SetFatherBirthDate] = useState("");
  const [FatherSex, setFatherSex] = useState("");
  const [Vinculo, setVinculo] = useState("");
  const [SonName, setSonName] = useState("");
  const [SonBirth, setSonBirth] = useState("");
  const [SonSex, setSonSex] = useState("");
  const [Question1, setQuestion1] = useState("");
  const [Question2, setQuestion2] = useState("");
  const [Question3, setQuestion3] = useState("");
  const [Question4, setQuestion4] = useState("");
  const [Question5, setQuestion5] = useState("");

  async function enviarRegistro() {
    const datosRegistro = {
      email: email,
      password: password,
      sexoId: parseInt(FatherSex, 10),
      padre: {
        nombre: FatherName,
        apellido: "", // Asume que aquí deberías tener un estado o prop para el apellido
        email: email, // Esto está bien si reutilizas el email para el padre
        tipoTutorId: parseInt(Vinculo, 10),
        fechaNacimiento: new Date(FatherBirthDate + "T00:00:00").toISOString(),
      },
      hijos: [
        {
          nombre: SonName,
          apellido: "", // Similar al apellido del padre, asumiendo que necesitas esto
          fechaNacimiento: new Date(SonBirth + "T00:00:00").toISOString(),
          sexoId: parseInt(SonSex, 10),
          preguntasRegistroHijo: [
            { preguntasRegistroId: 1, respuesta: Question1 },
            { preguntasRegistroId: 2, respuesta: Question2 },
            { preguntasRegistroId: 3, respuesta: Question3 },
            { preguntasRegistroId: 4, respuesta: Question4 },
            { preguntasRegistroId: 5, respuesta: Question5 },
          ],
        },
      ],
    };

    try {
      const respuesta = await axios.post(
        "https://teaapitest.azurewebsites.net/User/create-family",
        datosRegistro
      );
      console.log("Registro exitoso", respuesta.data);
      navigate("/Login");
      toast({
        title: "Success in registration",
        description: "User registered successfully. You can now log in.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    } catch (error) {
      console.error("Error al enviar la solicitud:", error);
      toast({
        title: "Error in registration",
        description: error.response
          ? error.response.data.message
          : "Could not register user. Please try again later.",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  }

  const handleContinue = () => {
    if (step < 4) {
      setStep(step + 1);
    } else {
      enviarRegistro();
    }
  };

  return (
    <div>
      <ChakraProvider>
        <CSSReset />

        <Flex
          as="nav"
          align="center"
          justify="end"
          padding="1rem"
          position="fixed"
          top="0"
          left="0"
          right="0"
          zIndex="999"
          background="transparent" // Cambiado a transparente para que se mezcle naturalmente con la página
          width="100%"
          borderBottomWidth="0" // Eliminando la línea divisoria que parece naturalmente de la página
        >
          {" "}
          <Box bottom="70px">
            <CustomButton
              textColor="#85BEB5"
              text="Log In"
              width="149px"
              height="50px"
              boxShadowColor="#FFFFFF"
              borderColor="#AEECE2"
              borderWidth="2px"
              backgroundColor="#FFFFFF"
              stroke="2px solid #AEECE2"
              to="/Login"
            />
          </Box>
        </Flex>
        <Center
          height="100%"
          width="100%"
          flexDirection="column"
          overflowY="auto"
        >
          <Box>
            <Center style={{ marginTop: "100px" }}>
              <img src={TeaLogo} alt="" />
            </Center>
          </Box>
          <Collapse in={step === 1}>
            <Center flexDirection="column" maxWidth="500px">
              <Box mb="31px">
                <Heading
                  as="h2"
                  size="xl"
                  color="#3C3C3C"
                  textAlign="center"
                  fontFamily="Inter"
                  fontSize="23px"
                  fontStyle="normal"
                  fontWeight="700"
                  lineHeight="40px"
                >
                  Create your account
                </Heading>
              </Box>

              <Box>
                <CustomInput
                  label="Email"
                  type="text"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Box>

              <Box>
                <CustomInput
                  label="Password"
                  type="password"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Box>

              <Box mb="41px">
                <CustomInput
                  label="Confirm your password"
                  type="password" /*onChange={(e) => setConfirmPassword(e.target.value)}*/
                />
              </Box>

              <Box mb="28px">
                <Center>
                  <Button text="Create your profile" onClick={handleContinue} />
                </Center>
              </Box>
            </Center>
          </Collapse>
          <Collapse in={step === 2}>
            <Center flexDirection="column" maxWidth="500px">
              <Box mb="31px">
                <Heading
                  as="h2"
                  size="xl"
                  color="#3C3C3C"
                  textAlign="center"
                  fontFamily="Inter"
                  fontSize="23px"
                  fontStyle="normal"
                  fontWeight="700"
                  lineHeight="40px"
                >
                  Step 1: Parent Information
                </Heading>
              </Box>

              <Box>
                <CustomInput
                  label="Full Name"
                  type="text"
                  onChange={(e) => setFatherName(e.target.value)}
                />
              </Box>

              <Box>
                <CustomInput
                  label="Birthdate"
                  type="date"
                  onChange={(e) => SetFatherBirthDate(e.target.value)}
                />
              </Box>

              <Box>
                <CustomInput
                  label="Genre"
                  type="select"
                  options={Data.gender}
                  onChange={(e) => setFatherSex(e.target.value)}
                />
              </Box>

              <Box mb="41px">
                <CustomInput
                  label="Bond"
                  type="select"
                  options={Data.familyBond}
                  onChange={(e) => setVinculo(e.target.value)}
                />
              </Box>

              <Box mb="28px">
                <Center>
                  <Button text="Continue" onClick={handleContinue} />
                </Center>
              </Box>
            </Center>
          </Collapse>
          <Collapse in={step === 3}>
            <Center flexDirection="column" maxWidth="500px">
              <Box mb="30px">
                <Heading
                  as="h2"
                  size="xl"
                  color="#3C3C3C"
                  textAlign="center"
                  fontFamily="Inter"
                  fontSize="23px"
                  fontStyle="normal"
                  fontWeight="700"
                  lineHeight="40px"
                >
                  Step 2: Child Information
                </Heading>
              </Box>

              <Box>
                <CustomInput
                  label="Full Name"
                  type="text"
                  onChange={(e) => setSonName(e.target.value)}
                />
              </Box>

              <Box>
                <CustomInput
                  label="Birthdate"
                  type="date"
                  onChange={(e) => setSonBirth(e.target.value)}
                />
              </Box>

              <Box mb="41px">
                <CustomInput
                  label="Genre"
                  type="select"
                  options={Data.gender}
                  onChange={(e) => setSonSex(e.target.value)}
                />
              </Box>

              <Box mb="28px">
                <Center>
                  <Button
                    text="Add another child"
                    onClick={handleContinue}
                    backgroundColor="#FDC99B"
                    boxShadowColor="#FFAFAD"
                  />
                </Center>
              </Box>

              <Box mb="28px">
                <Center>
                  <Button text="Continue" onClick={handleContinue} />
                </Center>
              </Box>
            </Center>
          </Collapse>

          <Collapse in={step === 4}>
            <Center flexDirection="column" maxWidth="500px">
              <Box mb="31px">
                <Heading
                  as="h2"
                  size="xl"
                  color="#3C3C3C"
                  textAlign="center"
                  fontFamily="Inter"
                  fontSize="23px"
                  fontStyle="normal"
                  fontWeight="700"
                  lineHeight="40px"
                >
                  Step 3: Diagnosis and Specific Needs
                </Heading>
              </Box>

              <Box>
                <CustomInput
                  label="Does your child have a diagnosis of ASD?"
                  type="select"
                  options={Data.optionsTea}
                  onChange={(e) => setQuestion1(e.target.value)}
                />
              </Box>

              <Box>
                <CustomInput
                  label={
                    "What emotional skills would you like your child to work on?"
                  }
                  type="select"
                  options={Data.emotions}
                  onChange={(e) => setQuestion2(e.target.value)}
                />
              </Box>

              <Box>
                <CustomInput
                  label="How does your child communicate?"
                  type="select"
                  options={Data.typeOfComunications}
                  onChange={(e) => setQuestion3(e.target.value)}
                />
              </Box>

              <Box>
                <CustomInput
                  label="Does your child have any sensory preferences?"
                  type="select"
                  options={Data.communications}
                  onChange={(e) => setQuestion4(e.target.value)}
                />
              </Box>

              <Box>
                <CustomInput
                  label="What are your child's challenges in understanding emotions?"
                  type="select"
                  options={Data.challenges}
                  onChange={(e) => setQuestion5(e.target.value)}
                />
              </Box>

              <Box mt="20px" mb="28px">
                <Center>
                  <Button text="Continue" onClick={handleContinue} />
                </Center>
              </Box>
            </Center>
          </Collapse>
        </Center>
      </ChakraProvider>
    </div>
  );
}

export default Register;
